<template>
  <div class="tax-explainer py-4">
    <div class="head_fee_content_title">
      <h3>Thuế</h3>
      <span>{{ report.totalTax | price }}</span>
    </div>
    <div class="price_wrap">
      <div v-if="isTeacherFreelance">
        <div class="d-flex justify-space-between my-1">
          <h3>Thuế suất</h3>
          <div>10%</div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex justify-space-between my-1">
          <h3>Thu nhập chịu thuế</h3>
          <div>{{ report.totalBeforeTax | price }}</div>
        </div>
        <div class="my-1">
          <div class="d-flex justify-space-between">
            <h3>Giảm trừ thuế</h3>
            <div>{{ get(report, 'taxExplain.taxReductionToIncome', 0) | price }}</div>
          </div>
          <div class="text-caption">{{ taxReductionToIncomeExplainer }}</div>
        </div>
        <div class="d-flex justify-space-between my-1">
          <h3>Thu nhập tính thuế</h3>
          <div>{{ get(report, 'taxExplain.taxAppliedIncome', 0) | price }}</div>
        </div>
        <div class="d-flex justify-space-between my-1">
          <h3>Thuế suất</h3>
          <div>{{ get(report, 'taxExplain.taxAppliedPercentage', 0) }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import get from 'lodash-es/get'
export default {
  data() {
    return { get }
  },
  computed: {
    ...mapGetters({
      report: 'salaryReport/report'
    }),
    isTeacherFreelance() {
      return this.report.salaryConfig === 'freelance'
    },
    taxReductionToIncomeExplainer() {
      let result = 'Giảm trừ thuế = '
      const salaryConfig = this.report.salaryConfig
      if (salaryConfig === 'pension') return result + 'Giảm trừ bản thân'
      result += 'Giảm trừ bản thân'
      const reduceOnDependent = get(this.report, 'taxReductionConfig.reduceOnDependent', false)
      const numberOfDepenencies = get(this.report, 'taxReductionConfig.numberOfDepenencies', 0)
      if (reduceOnDependent) result += `+ Giảm trừ người phụ thuộc x ${numberOfDepenencies}`
      return result + ' + Bảo hiểm'
    }
  }
}
</script>
<style lang="scss" scoped>
.tax-explainer {
  border-bottom: 1px solid #e0e0e0;
}

.collection-title {
  display: flex;
  justify-content: space-between;
}

.head_fee_content_title {
  font-weight: 500;
  font-size: 16px;
  color: #fd6b6b !important;
  display: flex;
  justify-content: space-between;
}

.head_fee_content_title h3,
.head_fee_content_title span {
  color: #fd6b6b !important;
}

.note {
  display: block;
  max-width: 70% !important;
  color: #797979;
  margin-bottom: 6px;
}
</style>
